<template>
  <div :class="containerClass">
    <div class="card-sticky bg-dark p-3 md:p-4 rounded-tl-xl rounded-bl-xl w-64 md:w-96">
      <div class="flex gap-4">
        <div class="w-4/12 md:w-5/12">
          <img :src="sellerImg" class="rounded-full border-2 border-primary">
        </div>
        <div class="w-8/12 md:w-6/12 text-white">
          <p class="font-bold text-sm sm:text-lg">{{ agentName }}</p>
          <p class="text-xs md:text-sm uppercase">{{ tr('Travel Specialist') }}</p>
          <div class="hidden md:block">
            <p class="text-sm">
              <img src="@/assets/trip/img/wpp.svg" class="inline-block mr-2">
              <span v-html="agentPhone"></span>
            </p>
            <p class="text-sm">
              <a :href="agentMeet" target="_blank">
                <img src="@/assets/trip/img/meet.svg" class="inline-block mr-2">
                {{ tr('Reserve a meet') }}
              </a>
            </p>
          </div>
          <a
            data-modal-target="default-modal"
            data-modal-toggle="default-modal"
            class="mt-1 md:mt-3 cursor-pointer underline md:no-underline inline-block md:px-5 py-1 text-sm md:border border-white rounded-sm md:hover:bg-white md:hover:text-dark transition-all"
            @click="$emit('open')"
          >
            {{ tr('More about me') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TravelSpecialistCard',
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['open'],
  computed: {
    containerClass() {
      return this.fullWidth
        ? 'font-primary relative w-full block text-dark'
        : 'relative';
    },
    agentName() {
      return this.$store.state.agentName;
    },
    agentMeet() {
      return this.$store.state.agentMeet;
    },
    agentPhone() {
      return this.$store.state.agentPhone;
    },
    sellerImg() {
      return this.$store.state.sellerImg;
    },
  },
  methods: {
    tr(key) {
      return this.$root.tr(key);
    },
  },
};
</script>
